import { finish, error } from '../../../modules/customers/actions/reality-check';

import api from '../../../api';

export function request(dispatch, { id, duration }) {
    api.put('/customers/' + id + '/reality-check', { duration }).then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, customer)),
            () => dispatch(finish(id))
        ),
        ({ errors }) => dispatch(error(id, errors))
    );
}
